import React from "react";
import { useSelector } from "react-redux";

import { RootState } from "store";
import { MinusIcon, PlusIcon, TimePickerPopup } from "shared/ui";
import { MINUTE_STEP } from "widgets/traiding-panel";
import { SwitchTimeButton } from "./SwitchTimeButton";
import styles from "./TradingPanel.module.css";

type TimeField = "hours" | "minutes" | "seconds";

interface Props {
  hours: number;
  minutes: number;
  seconds: number;
  duration: number;
  adjustDuration: (delta: number, stepSeconds?: number) => void;
  adjustField: (field: TimeField, delta: number) => void;
  setDuration: (seconds: number) => void;
  canSwitchTime: boolean;
  switchTimeEnabled: boolean;
  onToggleSwitchTime: () => void;
  expiryClockTime: string;
}

export const TimeControl: React.FC<Props> = ({
  hours,
  minutes,
  seconds,
  duration,
  adjustDuration,
  adjustField,
  setDuration,
  canSwitchTime,
  switchTimeEnabled,
  onToggleSwitchTime,
  expiryClockTime,
}) => {
  // Пресеты — ровно то, что прислал сервер в последнем t=10, без фильтрации.
  const presets = useSelector(
    (state: RootState) => state.trading.expirationLimits.expiration_presets_sec,
  );
  // Без явного шага хук возьмёт expiration_step_sec с сервера.
  const step = switchTimeEnabled ? MINUTE_STEP : undefined;

  return (
    <div className={styles.item}>
      <div className={styles.labelRow}>
        <label className={styles.label}>Time</label>
        {canSwitchTime && (
          <SwitchTimeButton
            enabled={switchTimeEnabled}
            onToggle={onToggleSwitchTime}
          />
        )}
      </div>
      <div className={styles.control}>
        <button
          className={styles.tradingButton}
          onClick={() => adjustDuration(-1, step)}
        >
          <MinusIcon />
        </button>
        {switchTimeEnabled ? (
          <span className={styles.clockDisplay}>{expiryClockTime}</span>
        ) : (
          <TimePickerPopup
            hours={hours}
            minutes={minutes}
            seconds={seconds}
            duration={duration}
            presets={presets}
            onAdjust={adjustField}
            onSelectPreset={setDuration}
          />
        )}
        <button
          className={styles.tradingButton}
          onClick={() => adjustDuration(1, step)}
        >
          <PlusIcon />
        </button>
      </div>
    </div>
  );
};
